import React, { Component } from 'react';
import "./Home.scss";
import Projects from './Projects';
import Certifications from './Certifications';
import AboutContainer from './AboutContainer';

export default class Home extends Component {



    consoleText(words, id, colors) {
        if (colors === undefined) colors = ['#fff'];
        var visible = true;
        var con = document.getElementById('console');
        var letterCount = 1;
        var x = 1;
        var waiting = false;
        var target = document.getElementById(id)
        target.setAttribute('style', 'color:' + colors[0])
        window.setInterval(function () {

            if (letterCount === 0 && waiting === false) {
                waiting = true;
                target.innerHTML = words[0].substring(0, letterCount)
                window.setTimeout(function () {
                    var usedColor = colors.shift();
                    colors.push(usedColor);
                    var usedWord = words.shift();
                    words.push(usedWord);
                    x = 1;
                    target.setAttribute('style', 'color:' + colors[0])
                    letterCount += x;
                    waiting = false;
                }, 1000)
            } else if (letterCount === words[0].length + 1 && waiting === false) {
                waiting = true;
                window.setTimeout(function () {
                    x = -1;
                    letterCount += x;
                    waiting = false;
                }, 1000)
            } else if (waiting === false) {
                target.innerHTML = words[0].substring(0, letterCount)
                letterCount += x;
            }
        }, 120)
        window.setInterval(function () {
            if (visible === true) {
                con.className = 'console-underscore hidden'
                visible = false;

            } else {
                con.className = 'console-underscore'

                visible = true;
            }
        }, 400)
    }

    async componentDidMount() {
        this.consoleText(["Programmer", "Car Enthusiast", "UX/UI Developer", "Javascript Engineer", "Front End Developer", "Investor"], "text", ["#9877e2"]);
    }

    render() {

        return (
            <div className="my-md-5">
                <h1>Hello! I am a </h1>
                <div className='console-container mb-md-5'>
                    <h1 id='text'></h1>
                    <div className='console-underscore' id='console'>
                    </div>
                </div>
                <div className="my-5">
                    <AboutContainer />
                </div>
                <div className="my-5">
                    <Projects projects={this.props.projects} />
                </div>
                <div className="my-5">
                    <Certifications />
                </div>
            </div>
        )
    }
}


